/* eslint-disable i18next/no-literal-string */
export default function About() {
  return (
    <div className="p-12">
      <h1 className="text-2xl font-bold">About</h1>
    </div>
  );
}
